import { Button, ControlGroup, InputGroup, Intent } from '@blueprintjs/core'
import PropTypes from 'prop-types'
import get from 'lodash/get'
import React from 'react'
import { Field, Form } from 'react-final-form'
import { AppToaster } from '../../../lib/toaster'

const validate = values => {
  const errors = {}
  if (!values.name) {
    errors.name = 'Pflichtfeld'
  }
  return errors
}

const NewCycleTemplateForm = ({ createFunction, refetch, style }) => {
  const onSubmit = async ({ name }) => {
    try {
      await createFunction(name)
      refetch()
      AppToaster.show({
        message: 'Zyklusvorlage angelegt.',
        intent: 'success',
      })
    } catch (e) {
      AppToaster.show({
        message: get(e.response.data, 'hydra:description'),
        intent: 'warning',
      })
    }
  }
  return (
    <Form
      onSubmit={onSubmit}
      validate={validate}
      render={({ handleSubmit, pristine, invalid, reset }) => (
        <form
          style={{ ...style }}
          onSubmit={async e => {
            await handleSubmit(e)
            reset()
          }}
        >
          <ControlGroup fill>
            <Field
              name="name"
              render={({ input, meta }) => (
                <InputGroup id="text-input" placeholder="Name" {...input} />
              )}
            />

            <Button
              icon="new-grid-item"
              type="submit"
              intent={Intent.SUCCESS}
              disabled={pristine || invalid}
            >
              Neue Zyklusvorlage erstellen
            </Button>
          </ControlGroup>
        </form>
      )}
    />
  )
}

NewCycleTemplateForm.propTypes = {
  createFunction: PropTypes.func.isRequired,
  refetch: PropTypes.func.isRequired,
  style: PropTypes.object,
}

export default NewCycleTemplateForm
